import saveAs from 'file-saver';
import toExcel from '@lolly-labs/q3-exports/lib/toExcel';

export default (...params) =>
  toExcel(...params).then((buf) => {
    saveAs(new Blob([buf]), 'export.xlsx');
  });
